import { StepStatusEnum } from "src/app/reports/enums/step-status.enum";

export class SaveStep {
  Status: StepStatusEnum;
  Description: string;
}
